import type { InferOutput } from 'valibot'
import { array, literal, nullish, object, string, union } from 'valibot'
import { commonSchema } from './common'

export const templateSchema = object({
  ...commonSchema.entries,
  nodeType: nullish(union([literal('contract_template'), literal('juridika_template')])),
  legal_areas: nullish(array(string())),
  files: nullish(array(string())),
  authorName: nullish(array(string())),
  lastUpdatedByEditor: nullish(array(string())),
  alias: nullish(string()),
})

export type Template = InferOutput<typeof templateSchema>
